import * as React from 'react';
import StatusContext from '../../../contexts/StatusContext';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';


export const ConfirmDialog = ({alertYes, openDialog, closeDialog, prompt}) => {

  let {
   changeLanguage,
} = React.useContext(StatusContext);

  const dialogStyle = {
    padding: "20px",
    fontSize: "16px",
    color:'maroon',
   
 };
 
  return (
    <Dialog onClose = {closeDialog} open = {openDialog}>
            <DialogTitle style={{fontSize:'20px'}}> DedaAI </DialogTitle>
           
            <h2 style = {dialogStyle}>
               {prompt}
            </h2>
            <div style = {{display: 'flex', width: '100%', justifyContent:'center', alignItems: 'center'}}>
            <button className="alertpromptbuttonYes" onClick={alertYes}>{changeLanguage('dialog', 'ok')}</button> 
            
            </div>
    </Dialog>
  );
}

